<template>
  <div style="padding: 10px">
    <div style="margin: 10px 0">
      <el-input v-model="search.accountName" placeholder="账号名" @keyup.enter.native="load" style="width: 10%"
                clearable></el-input>
      <el-input v-model="search.roleId" placeholder="角色ID" @keyup.enter.native="load" style="width: 10%"
                clearable></el-input>
      <el-select v-model="search.parentRoleId" clearable filterable placeholder="请选择父账号" style="width: 10%">
        <el-option
            v-for="item in parentIdDict"
            :key="item.parentRoleId"
            :label="item.accountName"
            :value="item.parentRoleId">
        </el-option>
      </el-select>
<el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button style="margin-left: 5px" @click="resetData">重置</el-button>
      <el-button type="warning" style="margin-left: 5px" @click="openSaltDialog">盐山助威</el-button>
      <el-button type="danger" style="margin-left: 5px" @click="openGuessDialog">盐山竞猜</el-button>
    </div>

    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="accountName"
          label="账号名">
      </el-table-column>
      <el-table-column prop="roleId" label="角色ID">
        <template #default="{row}">
        <span
            class="copyable-text"
            @click="copyToClipboard(row.roleId)"
        >
          {{ row.roleId }}
          <i class="el-icon-document-copy"></i>
        </span>
        </template>
      </el-table-column>
      <!-- 下次上号时间 -->
      <el-table-column
          label="下次收菜时间">
        <template #default="{row}">
          <span v-if="row.loginStatus === 0" style="color: #909399">不上号</span>
          <span v-else-if="!row.claimRewardStatus" style="color: #e6a23c">限时不收菜</span>
          <span v-else>{{ row.nextLoginTime }}</span>
        </template>
      </el-table-column>
      <!-- 下次爬塔时间 -->
      <el-table-column
          label="下次爬塔时间">
        <template #default="{row}">
          <span v-if="row.loginStatus === 0" style="color: #909399">不上号</span>
          <span v-else-if="!row.towerStatus" style="color: #e6a23c">不爬塔</span>
          <span v-else>{{ row.nextTowerTime }}</span>
        </template>
      </el-table-column>
      <!-- 下次怪异塔时间 -->
      <el-table-column
          label="下次怪异塔时间">
        <template #default="{row}">
          <span v-if="row.loginStatus === 0" style="color: #909399">不上号</span>
          <span v-else-if="!row.evotowerStatus" style="color: #e6a23c">不打怪异塔</span>
          <span v-else>{{ row.nextEvotowerTime }}</span>
        </template>
      </el-table-column>

      <!-- 是否上号 - Switch开关 -->
      <el-table-column
          label="是否上号">
        <template #default="{row}">
          <el-switch
              v-model="row.loginStatus"
              :active-value="1"
              :inactive-value="0"
              active-text="是"
              inactive-text="否"
              @change="handleStatusChange('loginStatus', row)">
          </el-switch>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="80px" v-if="this.userId === 1">
        <template #default="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

<div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!-- 盐山助威弹窗 -->
    <el-dialog
        title="盐山助威"
        v-model="saltDialogVisible"
        width="400px"
        @close="saltRound = null">
      <el-form label-width="80px">
        <el-form-item label="期数">
          <el-input-number v-model="saltRound" :min="1" :max="9999" controls-position="right"
                           style="width: 100%"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saltDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="saltLoading" @click="confirmSaltReward">确 定</el-button>
      </span>
    </el-dialog>
  <!-- 盐山竞猜弹窗 -->
    <el-dialog
        title="盐山竞猜"
        v-model="guessDialogVisible"
        width="500px"
        @close="guessTeamIds = ''">
      <el-form label-width="90px">
        <el-form-item label="队名列表">
          <el-input
              v-model="guessTeamIds"
              type="textarea"
              :rows="4"
              placeholder="请输入逗号分隔的队名，如：A10000245,A10002967,A10000003,A10000355"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="guessDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="guessLoading" @click="confirmGuess">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'accountInfo',
  components: {},
  data() {
    return {
      parentIdDict: [],
      userId: '',
      loading: true,
      search: {},
      query: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
tableData: [],
      // 防抖定时器
      debounceTimer: null,
      // 盐山助威弹窗
      saltDialogVisible: false,
      saltRound: null,
      saltLoading: false,
      // 盐山竞猜弹窗
      guessDialogVisible: false,
      guessTeamIds: '',
      guessLoading: false
    }
  },
  created() {
    this.load()
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;
  },
  mounted() {
    this.getParentIdList();
  },
  methods: {


    // 时间戳转日期
    formatTimestamp(timestamp) {
      if (!timestamp) return '无';
      const date = new Date(timestamp * 1000);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(/\//g, '-');
    },

    // Switch开关改变事件
    handleStatusChange(field, row) {
      // 防抖处理，避免频繁调用接口
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      this.debounceTimer = setTimeout(() => {
        this.updateStatus(field, row);
      }, 300);
    },

    // 更新状态到后端
    updateStatus(field, row) {
      this.loading = true;

      // 构建更新数据
      const updateData = {
        id: row.id,
        [field]: row[field]
      };

      request.post("/accountInfoWs/update", updateData).then(res => {
        this.loading = false;
        if (res.code === '0') {
          this.$message({
            type: "success",
            message: "更新成功"
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg || "更新失败"
          });
          this.load();
        }
      }).catch(error => {
        this.loading = false;
        this.$message({
          type: "error",
          message: "网络错误，更新失败"
        });
        this.load();
      });
    },

    async copyToClipboard(text) {
      const textToCopy = text.toString()

      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(textToCopy)
          this.$message.success('复制成功')
          return
        } catch (err) {
          console.warn('现代Clipboard API失败，使用降级方案')
        }
      }

      const textArea = document.createElement('textarea')
      textArea.value = textToCopy
      textArea.style.position = 'fixed'
      textArea.style.opacity = '0'

      document.body.appendChild(textArea)
      textArea.select()

      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message.success('复制成功')
        } else {
          this.$message.error('复制失败')
        }
      } catch (err) {
        this.$message.error('复制失败')
      } finally {
        document.body.removeChild(textArea)
      }
    },

    handleEdit(row) {
      // 跳转到新页面，传递roleId作为查询参数
      this.$router.push({
        path: '/saltedFish/accountInfoWsDetail',
        query: {
          roleId: row.roleId
        }
      })
    },

resetData() {
      this.search = {}
      this.load()
    },

    // 打开盐山助威弹窗
    openSaltDialog() {
      this.saltDialogVisible = true
    },

    // 确认执行盐山助威
    confirmSaltReward() {
      if (this.saltRound == null || this.saltRound <= 0) {
        this.$message({
          type: "warning",
          message: "请输入期数"
        })
        return
      }
      this.saltLoading = true
      request.get(`/xyzwws/websocket/apexTask7Reward/${this.saltRound}`, {}).then(res => {
        this.saltLoading = false
        if (res.code === '0') {
          this.$message({
            type: "success",
            message: "盐山助威执行完成"
          })
          this.saltDialogVisible = false
        } else {
          this.$message({
            type: "error",
            message: res.msg || "执行失败"
          })
        }
}).catch(error => {
        this.saltLoading = false
        this.$message({
          type: "error",
          message: "网络错误，执行失败"
        })
      })
    },

    // 打开盐山竞猜弹窗
    openGuessDialog() {
      this.guessDialogVisible = true
    },

    // 确认执行盐山竞猜
    confirmGuess() {
      const teamIds = (this.guessTeamIds || '').trim()
      if (!teamIds) {
        this.$message({
          type: "warning",
          message: "请输入队名列表"
        })
        return
      }
      this.guessLoading = true
      request.get("/xyzwws/websocket/apexGuess", {
        params: { teamIds }
      }).then(res => {
        this.guessLoading = false
        if (res.code === '0') {
          this.$message({
            type: "success",
            message: "盐山竞猜执行完成"
          })
          this.guessDialogVisible = false
        } else {
          this.$message({
            type: "error",
            message: res.msg || "执行失败"
          })
        }
      }).catch(error => {
        this.guessLoading = false
        this.$message({
          type: "error",
          message: "网络错误，执行失败"
        })
      })
    },

    getParentIdList() {
      request.get("/accountInfo/parentList", {}).then(res => {
        this.loading = false
        this.parentIdDict = res.data
      })
    },

    load() {
      this.loading = true
      const searchForm = {...this.search}
      let obj = Object.assign(searchForm, this.query)
      let reqData = {
        ...obj
      }
      reqData.current = this.currentPage
      reqData.size = this.pageSize
      request.get("/accountInfoWs/list", {
        params: reqData
      }).then(res => {
        this.loading = false
        this.tableData = res.data.records
        this.total = res.data.total

        // 确保数据格式正确
        this.tableData.forEach(row => {
          // 如果字段是字符串形式的布尔值，转换为布尔类型
          if (typeof row.claimRewardStatus === 'string') {
            row.claimRewardStatus = row.claimRewardStatus === 'true';
          }
          if (typeof row.towerStatus === 'string') {
            row.towerStatus = row.towerStatus === 'true';
          }
          if (typeof row.evotowerStatus === 'string') {
            row.evotowerStatus = row.evotowerStatus === 'true';
          }
        })
      })
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.load()
    },

    handleCurrentChange(pageNum) {
      this.currentPage = pageNum
      this.load()
    }
  }
}
</script>

<style scoped>
/* 可选：为Switch添加一些样式 */
.el-switch {
  margin: 2px 0;
}

/* 复制文本样式 */
.copyable-text {
  cursor: pointer;
  color: #409EFF;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.copyable-text:hover {
  text-decoration: underline;
}
</style>
